import { isOutSideBottom } from "../../Tooltip/utils/checkTooltipOutside";
var MOBILE_INDENT = 16;
var TABLET_DESKTOP_INDENT = 32;
export var calculatePosition = function calculatePosition(_ref) {
  var dropdownRect = _ref.dropdownRect,
    containerHeight = _ref.containerHeight,
    isMobile = _ref.isMobile;
  var nextPosition = 'bottom';

  // проверяем выход за пределы экрана снизу
  var checkOutsideBottom = isOutSideBottom({
    tooltipMessageRect: dropdownRect,
    containerHeight: containerHeight,
    gap: isMobile ? MOBILE_INDENT : TABLET_DESKTOP_INDENT
  });
  if (checkOutsideBottom) {
    nextPosition = 'top';
  }
  return nextPosition;
};